import { useState, useEffect } from 'react';
import { X } from 'lucide-react';
import { Link } from 'react-router-dom';
import { useTranslation, Trans } from 'react-i18next';

export function CookieConsent() {
  const { t } = useTranslation();
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    // Check if user has already accepted cookies
    const hasAccepted = localStorage.getItem('cookieConsent');
    if (!hasAccepted) {
      // Delay showing the toast slightly for better UX
      const timer = setTimeout(() => {
        setIsVisible(true);
      }, 1000);
      return () => clearTimeout(timer);
    }
  }, []);

  const acceptCookies = () => {
    localStorage.setItem('cookieConsent', 'true');
    setIsVisible(false);
  };

  if (!isVisible) return null;

  return (
    <div className="fixed bottom-4 left-4 right-4 md:left-auto md:right-4 md:max-w-md z-50 bg-zinc-900 border border-white/10 shadow-2xl p-4 flex flex-col gap-3 rounded-sm">
      <div className="flex justify-between items-start gap-4">
        <p className="text-zinc-300 text-sm font-light leading-relaxed">
          <Trans i18nKey="cookies.text">
            Este sitio utiliza cookies. Al continuar usando este sitio web, usted acepta su uso. Para obtener más información, consulte nuestra <Link to="/politica-de-privacidad" className="text-white underline hover:text-zinc-300 transition-colors">Política de privacidad</Link>.
          </Trans>
        </p>
        <button 
          onClick={acceptCookies}
          className="text-zinc-500 hover:text-white transition-colors flex-shrink-0 p-1"
          aria-label={t("cookies.close_aria")}
        >
          <X size={18} />
        </button>
      </div>
      <div className="flex justify-end mt-1">
        <button
          onClick={acceptCookies}
          className="text-xs uppercase font-neocat tracking-widest bg-white text-zinc-950 hover:bg-zinc-200 transition-colors px-4 py-2 font-bold"
        >
          {t("cookies.accept_button")}
        </button>
      </div>
    </div>
  );
}
